document.addEventListener("DOMContentLoaded", function () {

  function updateImages() {
    let productData = window.productJson || JSON.parse(document.querySelector('[type="application/json"][data-product-json]').textContent);

    if(window.location.href.includes('?variant=') && productData.options.length == 2){
      setTimeout(() => {
        if (!productData?.variants) {
          return;
        }

        const url = new URL(window.location.href);
        const selectedVar = parseInt(url.searchParams.get('variant'), 10);
        const variant = productData.variants.find(vnt => vnt.id == selectedVar);

        if (!variant) {
          return;
        }

        const selectedOption1 = variant.option1 || null;
        if (!selectedOption1) {
          return;
        }

        productData.variants.forEach(variant => {
          if (variant.option1 == selectedOption1 && variant.featured_image?.src && variant.option2) {
            const imgElement = document.querySelector(`.media-swatch--custom[data-option-value="${variant.option2}"] img`);
            const customSwatch = window.swatches?.find(v => v.id == variant.id)?.swatch;

            if (imgElement && variant.featured_image.src) {
              imgElement.src = customSwatch || variant.featured_image.src;
              const baseImageUrl = variant.featured_image.src.split('?')[0]; 
              // imgElement.srcset = `${baseImageUrl}?v=${variant.featured_image.src.split('v=')[1]}&width=120 120w, ${baseImageUrl}?v=${variant.featured_image.src.split('v=')[1]}&width=240 240w`;
              imgElement.srcset = customSwatch || variant.featured_image.src;
            }
          }
        });
      }, 10);

    }
  }

  updateImages();
  
  const swatches = document.querySelectorAll(".media-swatch--custom");
  // Füge die Klasse zum ersten Swatch hinzu, wenn sie existieren
  if (swatches.length > 0) {
    let img = []
    let active = document.querySelector('.media-swatch--custom--selected').querySelector('img').src.split('https:')[1]

    swatches.forEach((swatch) => {
      let src = swatch.querySelector('img').src
      img.push(src)
      swatch.addEventListener("click", () => {

        updateImages();

        // Ausgewählte Klasse von allen Swatches entfernen
        swatches.forEach((sw) =>
          sw.classList.remove("media-swatch--custom--selected")
        );
  
        if(document.querySelector('.price-per-kg')) {
          document.querySelector('.price-per-kg').innerHTML = swatch.dataset.pricekg
        }

        // Füge die ausgewählte Klasse zum angeklickten Swatch hinzu
        swatch.classList.add("media-swatch--custom--selected"); 

        active = document.querySelector('.media-swatch--custom--selected').querySelector('img').src.split('https:')[1]
        
        // thumbnail
        img.forEach(function(src) {
          src = src.split('https:')[1]
          document.querySelector(`.product-gallery__thumbnail img[src="${src}"]`).closest('.product-gallery__thumbnail').style.display = 'none'
        })
    
        document.querySelector(`.product-gallery__thumbnail img[src="${active}"]`).closest('.product-gallery__thumbnail').style.display = 'block'
        
        // main
        img.forEach(function(src) {
          src = src.split('https:')[1]
          document.querySelector(`.product-gallery__media img[src="${src}"]`).closest('.product-gallery__media').style.display = 'none'
        })

        document.querySelector(`.product-gallery__media img[src="${active}"]`).closest('.product-gallery__media').style.display = 'block'
      });
    });
  
    // thumbnail
    img.forEach(function(src) {
      src = src.split('https:')[1]
      document.querySelector(`.product-gallery__thumbnail img[src="${src}"]`).closest('.product-gallery__thumbnail').style.display = 'none'
    })

    document.querySelector(`.product-gallery__thumbnail img[src="${active}"]`).closest('.product-gallery__thumbnail').style.display = 'block'

    // main
    img.forEach(function(src) {
      src = src.split('https:')[1]
      document.querySelector(`.product-gallery__media img[src="${src}"]`).closest('.product-gallery__media').style.display = 'none'
    })

    document.querySelector(`.product-gallery__media img[src="${active}"]`).closest('.product-gallery__media').style.display = 'block'
  }
  
});
  



